import { useState } from "react";
import { useAuthenticatedApiClient } from "@/hooks/useAuthenticatedApiClient";
import FinancialApplicationApiClient from "@/api/financialApplicationApiClient";
import { LinkUserRequest, ShareApplicationPerson } from "@/types/ShareApplication";

export const useLinkUser = () => {
  const [isLinking, setIsLinking] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const financialApplicationApiClient = useAuthenticatedApiClient(FinancialApplicationApiClient);

  const linkUser = async (financialApplicationId: string, person: ShareApplicationPerson) => {
    if (!person.potentialUserId) {
      throw new Error("No potential user ID found for this person");
    }

    setIsLinking(true);
    setError(null);

    try {
      const request: LinkUserRequest = {
        userId: person.potentialUserId,
        role: person.role,
        keyPersonOrJointOwnerId: person.keyPersonOrJointOwnerId,
      };

      const response = await financialApplicationApiClient.linkUser(
        financialApplicationId,
        request
      );
      return response;
    } catch (err) {
      const errorMessage = err instanceof Error ? err.message : "Failed to link user";
      setError(errorMessage);
      throw err;
    } finally {
      setIsLinking(false);
    }
  };

  return {
    linkUser,
    isLinking,
    error,
  };
};
